import React, { useEffect, useRef, useState } from "react";
import apiService from "../../APIService";
// import jsPDF from "jspdf";

import MessageA1 from "./MessageA1";
import MessageA3 from "./MessageA3";
import MessageA4 from "./MessageA4";
import MessageA3F from "./MessageA3F";
import MessageA7 from "./MessageA7";
import MessageA13 from "./MessageA13";
import MessageA14 from "./MessageA14";
import MessageA15 from "./MessageA15";
import MessageA19 from "./MessageA19";
import MessageA20 from "./MessageA20";
import MessageA21 from "./MessageA21";
import MessageA22 from "./MessageA22";
import MessageA23 from "./MessageA23";
import MessageA24 from "./MessageA24";

import MessageA14C from "./MessageA14c";

import MessageRedirect from "./MessageRedirect";

import secureLocalStorage from "react-secure-storage";

import "../../HelpAssistant/HelpAssistant.css";
import MessageA13s from "./MessageA13s";
import MessageA1i from "./MessageA1i";

var isIdleMsg = true;

const Conversation = (props) => {
  const timeCurrent =
    new Date().toLocaleTimeString("en-us").split(":")[0] +
    ":" +
    new Date().toLocaleTimeString("en-us").split(":")[1] +
    " " +
    new Date().toLocaleTimeString("en-us").substr(-2);

  let [currentData, setCurrentData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [initalState, setInitalState] = useState([]);
  const [textOnClick, setTextOnClick] = useState();
  const [showBanner, setShowBanner] = useState(false);
  const [bannerData, setBannerData] = useState();
  const [showRecharge, setShowRecharge] = useState(false);
  const [rechargeData, setRechargeData] = useState();
  const [historyData, setHistoryData] = useState();
  const [showHistory, setShowHistory] = useState(props.showHistory);
  const [isLoading, setIsLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [auth, setAuth] = useState(props.auth);
  const [enableTextBox, setEnableTextBox] = useState(false);
  const[feedBackIndex ,setFeedBackIndex] =useState(0);

  const messagesEndRef = useRef(null);

  const [chatEnd, setChatEnd] = useState(false);
  const [finalTimerFlag, setFinalTimerFlag] = useState(false);

  let idleTimer;
  let secondIdleTimer;
  let finalTimer;

  const [idleTime, setIdleTime] = useState(0);

  const inputValue = useRef(null);

  useEffect(() => {
    let isFinalTimerTriggered = false;

    const handleUserActivity = () => {
      clearTimeout(idleTimer);
      clearTimeout(secondIdleTimer);

      if (!chatEnd) {
        setIdleTime(0);
      }

      if (!chatEnd && !isFinalTimerTriggered) {
        clearTimeout(finalTimer);

        idleTimer = setTimeout(() => {
          setIdleTime(idleTime + 1);
          let initialArray = [];
          initialArray.push({
            uiCommand: "idle",
            text: "Hey there! We're eagerly waiting for you & we'd love to help you with your query.",
          });

          setCurrentData(initialArray);
        }, 1 * 60 * 1000);

        finalTimer = setTimeout(() => {
          apiService.userActivity("3").then((res) => {
            console.log(res);
          });
          setIdleTime(idleTime + 1);
          props.setIsSessionExpired(true);
          isFinalTimerTriggered = true;
          setFinalTimerFlag(true);
          props.setShowIdlePopup(true);
          props.setIsClearChatModal(false);
        }, 30 * 60 * 1000);
      }
    };

    const resetIdleTimer = () => {
      handleUserActivity();
    };

    if (!finalTimerFlag && !chatEnd && !props.isChatWithUs) {
      window.addEventListener("click", resetIdleTimer);
    }

    if (chatEnd) {
      clearTimeout(idleTimer);
      clearTimeout(finalTimer);
    }

    return () => {
      clearTimeout(idleTimer);
      clearTimeout(finalTimer);
    };
  }, [isIdleMsg]);

  useEffect(() => {
    if (finalTimerFlag) {
      let n = document.getElementsByClassName("action-tab");

      for (let i = 0; i < n.length; i++) {
        n[i].disabled = true;
        n[i].style.cursor = "not-allowed";
      }
    }
  }, [finalTimerFlag]);

  window.s360BannerCallback = (code) => {
    handleClick(code);
    if (code === "1.6.1.1.1.12.13.17") setTextOnClick("Register Now");
    else if (code === "1.6.1.1.1.12.13.17.1.1") setTextOnClick("Done");
  };

  useEffect(() => {
    setAuth(props.auth);
  }, [props.auth]);

  useEffect(() => {
    if (currentData?.length === 0) {
      setCurrentData(props.chatData);
    }
  }, [props.chatData, currentData]);

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  };

  //new addition 1
  useEffect(() => {
    setCurrentData(props.currentData);
  }, [props.currentData]);

  //
  useEffect(() => {
    if (props.login && !props.outSideLink && !props.action) {
      setInitialLoading(true);
      apiService.initialState().then((response) => {
        const data =
          response.data &&
          response.data.chatResponse &&
          response.data.chatResponse.entries;

        props.handleInputBox(response.data.chatResponse.enableDefaultTextBox);

        setInitialLoading(false);
        data &&
          data.map((i) => {
            if (i.uiCommand === "A41") {
              setShowBanner(true);
              setBannerData(i);
            }
            if (i.uiCommand === "A40") {
              setShowRecharge(true);
              setRechargeData(i);
            }
          });
        setCurrentData(data);
        data &&
          data.map((item, index) => item.code && initalState.push(item.code));
      });
    }
  }, [props.login]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const redirectClick = async (code, input, tag) => {
    let response;
    try {
      response = await apiService.chatPostPacks(code, input);

      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;

      if (data) {
        data.forEach((el) => {
          if (
            el.text === "Thank you for contacting Tata Play. Happy viewing!"
          ) {
            isIdleMsg = false;
          } else {
            isIdleMsg = true;
          }
        });
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setTextOnClick("");
    }
  };

  // const fetchConversationDetails = async (sessionId) => {
  //   try {
  //     const res = await apiService.getConversationDetails(sessionId);
  //     return res.data.data;
  //   } catch (error) {
  //     console.error("fetchConversationDetails error:", error);
  //   }
  // };

  // const generatePDF = (conversations) => {
  //   const doc = new jsPDF();
  //   let y = 10; // initial y position
  //   const marginBottom = 20; // bottom margin

  //   conversations.forEach((chat) => {
  //     if (!chat) return; // Ensure chat is not null or undefined

  //     doc.text(10, y, `Time: ${chat.time}`);
  //     y += 10;

  //     let isFirstBotMessage = true;

  //     chat.botResponse.entries.forEach((entry) => {
  //       if (!entry) return; // Ensure entry is not null or undefined

  //       const textToAdd = isFirstBotMessage ? `Bot: ${entry.text}` : entry.text;
  //       const splitText = doc.splitTextToSize(textToAdd, 180);

  //       if (
  //         y + splitText.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitText);
  //       if (isFirstBotMessage) isFirstBotMessage = false;
  //       y += splitText.length * 10;
  //     });

  //     if (chat.userResponse) {
  //       const userResponseText = `User: ${chat.userResponse.text}`;
  //       const splitUserResponse = doc.splitTextToSize(userResponseText, 180);

  //       if (
  //         y + splitUserResponse.length * 10 >
  //         doc.internal.pageSize.height - marginBottom
  //       ) {
  //         doc.addPage();
  //         y = 10;
  //       }

  //       doc.text(10, y, splitUserResponse);
  //       y += splitUserResponse.length * 10;
  //     }

  //     y += 10; // add some space before the next chat block
  //   });

  //   return doc.output("blob");
  // };

  // const uploadConversationPDF = async (sessionId, pdfBlob) => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("file", pdfBlob, "conversation.pdf");
  //     formData.append("sessionId", sessionId);
  //     formData.append("bot", "oriserve");

  //     const response = await apiService.uploadConversationMedia(
  //       formData,
  //       sessionId
  //     );
  //     if (response.data.code !== 200) throw new Error("File upload failed");
  //     return response.data;
  //   } catch (error) {
  //     console.error("uploadConversationPDF error:", error);
  //   }
  // };

  // const fetchUserActivity = async () => {
  //   try {
  //     const res = await apiService.userActivity("1");
  //     const { code, sessionId } = res.data;
  //     if (code !== 200 || !sessionId) throw new Error("Invalid response");
  //     return sessionId;
  //   } catch (error) {
  //     console.error("fetchUserActivity error:", error);
  //   }
  // };

  const handleClick = async (code, input, label, tag) => {
    props.setHideFooter(false);
    clearTimeout(idleTimer);
    clearTimeout(secondIdleTimer);
    clearTimeout(finalTimer);

    setIsLoading(true);

    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    let inputs = document.getElementsByClassName("form-control");

    for (let i = 0; i < inputs?.length; i++) {
      inputs[i].style.cursor = "not-allowed"; // Set cursor style
      inputs[i].disabled = true; // Disable input elements
      // Optional styles if needed:
      // elements[i].style.opacity = "0.5";
      // elements[i].style.pointerEvents = "none";
    }

    const typingTimeout = setTimeout(() => {
      props.setDelayBotResponse(true);
    }, 1000);

    let response;

    try {
      if (tag === "A58") {
        response = await apiService.chatPost(code, input);
      } else if (tag === "A59" || tag === "A63") {
        response = await apiService.chatPostPacks(code, input);
      } else {
        response = await apiService.chat(code, input, label);
      }

      clearTimeout(typingTimeout); // Clear the typing timeout if API response received
      props.setDelayBotResponse(false);

      setIsLoading(false);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;

      if (response?.data?.chatResponse?.end) {
        props.setDisabledEntryIcons(true);
        // setTimeout(async () => {
        //   try {
        //     const sessionId = await fetchUserActivity();
        //     const conversationDetails = await fetchConversationDetails(sessionId);
        //     const pdfBlob = generatePDF(conversationDetails);
        //     await uploadConversationPDF(sessionId, pdfBlob);


        //   } catch (error) {
        //     console.error("handleConfirm error:", error);
        //   }
        // }, 1000);

        setTimeout(() => {
          window.parent.postMessage({ endChatURL: "true" }, "*");
          apiService.userActivity("4").then((res) => {
            console.log(res);
          });
        }, 3000);
      }

      props.handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (response?.data?.chatResponse?.end === true && !chatEnd) {
        setChatEnd((val) => !val);
      }

      setCurrentData(data);
      setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

      if (data) {
        data.forEach((el) => {
          if (
            el.text === "Thank you for contacting Tata Play. Happy viewing!"
          ) {
            isIdleMsg = false;
          } else {
            isIdleMsg = true;
          }
        });
      }

      // if (data && data.some((el) => el?.uiCommand === "A1")) {
      //   props.setHideFooter(true);
      // }
      if (
        data &&
        data.some((el) => el?.uiCommand === "A1" && el.text.includes("Yes"))
      ) {
        props.setHideFooter(true);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setTextOnClick("");
    }
  };

  useEffect(() => {
    let n = document.getElementsByClassName("action-tab");

    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.cursor = "not-allowed";
      n[i].style.opacity = 0.5;
      n[i].style.pointerEvents = "none";
    }

    if (props.textMessage.key1) {
      let data = {
        data: "John",
        uiCommand: "A7",
        text: props.textMessage.key1,
      };
      props.setMergeUI(true);
      setCurrentData([data]);

      if (
        props.textMessage.dontSend === undefined &&
        props.textMessage !== ""
      ) {
        apiService.chat(null, props.textMessage).then((response) => {
          setIsLoading(false);
          const data =
            response.data &&
            response.data.chatResponse &&
            response.data.chatResponse.entries;
          props.handleInputBox(
            response?.data?.chatResponse?.enableDefaultTextBox
          );
          if (data) {
            data.forEach((el) => {
              if (
                el.text === "Thank you for contacting Tata Play. Happy viewing!"
              ) {
                isIdleMsg = false;
              } else {
                isIdleMsg = true;
              }
            });
          }
          setCurrentData(data);
          setEnableTextBox(response?.data?.chatResponse?.enableDefaultTextBox);

          var parsedData = null;
          if (data[2] !== undefined && data[2].uiCommand === "A58") {
            parsedData = JSON.parse(JSON.stringify(data[2])).text_data;
            let temp = new Object();
            temp["selectedLanguages"] =
              parsedData?.filter?.language?.selectedLanguages;
            temp["selectedGenre"] = parsedData?.filter?.genre.selectedGenre;

            localStorage.setItem(
              "selectedLanguagesAndGenresTemp",
              JSON.stringify(temp)
            );
          }
        });
      }
    }
    setTextOnClick();
  }, [props.textMessage]);

  useEffect(() => {
    let data;
    if (textOnClick) {
      const isImage =
        textOnClick.includes("http://localhost:3000/") ||
        textOnClick.includes("https://d2w1s20s54h788.cloudfront.net/") ||
        textOnClick.includes("https://unifiedbotchat.tataplay.com/");

      data = (
        <div className="onclick-openwrapp section0 userchatmsg0_1 userchatmsg">
          <div
            className="onclick-inner"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 7,
            }}
          >
            <div className="send-text-wrap">
              {isImage ? (
                <img style={{ width: "160px" }} src={textOnClick} alt="click" />
              ) : (
                <span className="packs-text">{textOnClick}</span>
              )}

              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="delivery-time-first">
                  {timeCurrent}
                  <span>
                    <svg
                      fill="currentColor"
                      preserveAspectRatio="xMidYMid meet"
                      height="13"
                      width="13"
                      viewBox="0 0 40 40"
                      class="ori-lr-mrgn-3"
                    >
                      <g>
                        <path d="m14.5 26.6l18-18 2.5 2.4-20.5 20.4-9.5-9.5 2.5-2.4z"></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    if (data) {
      setMessages([...messages, data]);
    }
  }, [textOnClick]);

  const messageContent = (data, dataObj) => {
    let messageComponents = [];

    for (let index = 0; index < data.length; index++) {
      const item = data[index];
      if (item?.uiCommand == "A3f") {
        dataObj.isA3F = true;
        break;
      }
      messageComponents.push(
        <div style={{ width: "100%" }}>
          {item.uiCommand === "A3" && (
            <>
              <MessageA3 item={item} index={index} />
            </>
          )}

          {item.uiCommand === "A4" && (
            <MessageA4
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
            />
          )}

          {item.uiCommand === "A7" && (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <MessageA7 item={item} setTextOnClick={setTextOnClick} />
            </div>
          )}

          {item.uiCommand === "A13s" && (
            <MessageA13s item={item} inputValue={inputValue} />
          )}


          {item.uiCommand === "Redirect" && (
            <MessageRedirect
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              redirectClick={redirectClick}
            />
          )}

          {item.uiCommand === "A13" && (
            <MessageA13 item={item} inputValue={inputValue} />
          )}

          {item.uiCommand === "A14" && (
            <MessageA14 item={item} inputValue={inputValue} />
          )}
          {item.uiCommand === "A14c" && (
            <MessageA14C item={item} inputValue={inputValue} />
          )}
          {item.uiCommand === "A15" && (
            <MessageA15
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              disabled={true}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A19" && <MessageA19 item={item} />}
          {item.uiCommand === "A20" && <MessageA20 item={item} />}
          {item.uiCommand === "A21" && (
            <MessageA21
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A22" && (
            <MessageA22
              item={item}
              handleClick={handleClick}
              setTextOnClick={setTextOnClick}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A23" && (
            <div  key= {index} style={{float : 'left' ,margin : '0px 10px'}} className="A23-container">
              <MessageA23
                item={item}
                handleClick={handleClick}
                setTextOnClick={setTextOnClick}
                inputValue={inputValue}
              />
            </div>
          )}

          {item.uiCommand === "A24" && (
            <MessageA24
              item={item}
              inputValue={inputValue}
            />
          )}

          {item.uiCommand === "A1i" && (
            <MessageA1i
            item={item}
            handleClick={handleClick}
            setTextOnClick={setTextOnClick}
            />
          )}

          {item.uiCommand === "A1e" &&
            secureLocalStorage.setItem("specialCode", item.code)}
        </div>
      );
    }

    return messageComponents;
  };

  useEffect(() => {
    let data;
    let dataObj = {};
    data =
      currentData &&
        currentData.length > 0 &&
        currentData[0]?.uiCommand !== "idle" ? (
        <>
          <div
            className={
              currentData[0]?.uiCommand === "A3f"
                ? "empty-bot"
                : currentData[0]?.uiCommand !== "A7"
                  ? "current-data-wrap"
                  : "sent-msg"
            }
          >
            {currentData[0]?.uiCommand !== "A7" && (
              <div
                className="chat-person"
                style={{ marginTop: "10px", marginRight: "10px" }}
              >
                <img
                  style={{ width: "32px" }}
                  src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                  alt=""
                />
              </div>
            )}
            <div
              className={
                props.mergeUI && textOnClick === undefined
                  ? `mergeConversation`
                  : "no-wrap"
              }
            >
              {messageContent(currentData, dataObj)}

              {!dataObj?.isA3F && (
                <div className="A1-container">
                  {currentData.map((item, index) => {
                    return (
                      <>
                        {item.uiCommand === "A1" && (
                          <>
                            <MessageA1
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                            />
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              )}

              <div style={{ marginLeft: "2%" }}>
                {currentData.length > 0 &&
                  currentData[0].uiCommand !== "A7" && (
                    <div className="delivery-time-first">{timeCurrent}</div>
                  )}
              </div>
            </div>
          </div>

          <>
            {dataObj?.isA3F && (
              <div style={{ display: "flex" }}>
                <div
                  className="chat-person"
                  style={{ marginRight: "10px", visibility: "hidden" }}
                >
                  <img
                    style={{ width: "32px" }}
                    src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                    alt=""
                  />
                </div>
                <div
                  className={
                    props.mergeUI && textOnClick === undefined
                      ? `clickWrap`
                      : "no-wrapp"
                  }
                >
                  {currentData.map((item, index) => {
                    return (
                      <div style={{ width: "100%" }}>
                        {item.uiCommand === "A3f" && (
                          <div className="A3-container">
                            <MessageA3F
                              item={item}
                              handleClick={handleClick}
                              setTextOnClick={setTextOnClick}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                   <div  style ={{ marginBottom : '20px' , gap : '12px'}} className="A23-container">
                  {currentData?.map((item, index) => {
                    if (item?.text === "Thumbs Up") {
                      setFeedBackIndex(prevIndex => prevIndex + 1);
                    }
                    return (
                      <>
                        {item.uiCommand === "A23" && (
                          <>
                             <div key= {index} className="A23-container">
                              <MessageA23
                                item={item}
                                handleClick={handleClick}
                                setTextOnClick={setTextOnClick}
                                inputValue={inputValue}
                                index ={feedBackIndex}
                              
                              />
                            </div>
                          </>
                          
                        )}
                      </>
                    );
                  })}
                </div>
                  <div className="A1-container">
                    {currentData.map((item, index) => {
                      return (
                        <>
                          {item.uiCommand === "A1" && (
                            <>
                              <MessageA1
                                item={item}
                                handleClick={handleClick}
                                setTextOnClick={setTextOnClick}
                              />
                            </>
                          )}
                        </>
                      );
                    })}
                  </div>
                  <div style={{ marginLeft: "2%" }}>
                    {currentData.length > 0 &&
                      currentData[0].uiCommand !== "A7" && (
                        <div className="delivery-time-first">{timeCurrent}</div>
                      )}
                  </div>
                  {(dataObj.isA3F = true)}
                </div>
              </div>
            )}
          </>
        </>
      ) : (
        currentData &&
        !finalTimerFlag &&
        currentData.map((item, index) => {
          return (
            <div style={{ width: "100%", display: "flex" }}>
              {item.uiCommand === "idle" && (
                <>
                  <div
                    className="chat-person"
                    style={{ marginRight: "10px", visibility: "hidden" }}
                  >
                    <img
                      style={{ width: "32px" }}
                      src="https://help.tataplay.com/uploads/templateimages/logo.c1bb6180.png"
                      alt=""
                    />
                  </div>
                  <div className="idle-wrap">
                    <p style={{ margin: 0 }}>{item.text}</p>
                    <div
                      style={{ fontSize: 10, color: "#abaeb2", marginTop: 4 }}
                    >
                      {timeCurrent}
                    </div>
                  </div>
                </>
              )}{" "}
            </div>
          );
        })
      );

    if (data) {
      setMessages([...messages, data]);
    }
  }, [currentData]);

  return (
    <div className="container">
      {props.thirdOkay && (
        <div className="chat-box-wrapper">
          <div class="coach-screen-inner"></div>
        </div>
      )}
      {props.loginLoader ? (
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      ) : (
        <>
          {initialLoading && !props.historyLoader && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
          {showHistory && props.sth && (
            <>
              {" "}
              {props.historyLoader ? (
                <div class="spinner">
                  <div class="bounce1"></div>
                  <div class="bounce2"></div>
                  <div class="bounce3"></div>
                </div>
              ) : (
                <div> {historyData}</div>
              )}
            </>
          )}
          <div className={props.mergeUI ? "mergeUI-chat-icon-flex" : "block"}>
            {messages}
          </div>
          {props.isLoading && (
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          )}
        </>
      )}
      <div ref={messagesEndRef} style={{ height: "10px" }} />
    </div>
  );
};

export default Conversation;
